import { Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateRange } from '~/types/Shared'

import EventLogFilters from './CallQueue/EventLogFilters'
import EventLogTable from './CallQueue/EventLogTable'
import { useDashboardContext } from './context/DashboardContext'

export const EventLogPage = () => {
  const { t } = useTranslation()
  const { callCenterEnabled } = useDashboardContext()
  // Match EventLogFilters' default so the first render already has the range
  // the filter will emit — otherwise mount fires a dateless fetch, then a
  // second one once the filter pushes up its last-30-days default.
  const [dateTimeRange, setDateTimeRange] = useState<DateRange>(
    DateRange.last30Days(),
  )
  const [agentUserId, setAgentUserId] = useState<string | undefined>(undefined)

  if (!callCenterEnabled) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100%">
        <Text>{t('dashboards.noDataAvailable')}</Text>
      </Flex>
    )
  }

  return (
    <>
      <EventLogFilters
        onDateTimeRangeChange={setDateTimeRange}
        onAgentChange={setAgentUserId}
      />
      <Flex
        padding="1.25rem"
        flexDirection="column"
        alignItems="center"
        gap="0.25rem"
        flex="1 0 0"
        minH="0"
        alignSelf="stretch"
        overflow="hidden"
      >
        <EventLogTable
          dateTimeRange={dateTimeRange}
          agentUserId={agentUserId}
        />
      </Flex>
    </>
  )
}
